const LOGO = "https://customer-assets.emergentagent.com/job_telemedicine-plus-1/artifacts/si76u1vy_image.png";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[color:var(--brand-navy-deep)] text-slate-200 mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img
              src={LOGO}
              alt="HappiBandhu"
              className="h-14 w-14 bg-white rounded-xl p-1"
            />
            <div>
              <div className="font-display text-2xl font-bold text-white">
                HappiBandhu
              </div>
              <div className="text-xs tracking-[0.2em] uppercase text-pink-300">
                Har Parivaar Ka Apna Bandhu
              </div>
            </div>
          </div>
          <p className="mt-5 text-sm text-slate-300 max-w-md leading-relaxed">
            HappiBandhu is a wellness membership marketplace bringing affordable
            healthcare access to every Indian family — powered by our trusted providers.
          </p>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-4">Explore</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><a href="#plans" className="hover:text-white">Plans</a></li>
            <li><a href="#benefits" className="hover:text-white">Benefits</a></li>
            <li><a href="#plan" className="hover:text-white">Plan</a></li>
            <li><a href="#faq" className="hover:text-white">FAQ</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white mb-4">Support</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li>Help Center</li>
            <li>Contact</li>
            <li>Privacy Policy</li>
            <li>Terms of Service</li>
            <li>
              <a href="/admin/login" className="hover:text-white">
                Admin
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-slate-400">
          <span>© 2026 HappiBandhu. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
